// Social media platform icons

// Export all icons from platform subfolders
export * from "./discord";
export * from "./x";
export * from "./telegram";
export * from "./github";
export * from "./linkedin";

// Twitter (deprecated - use XIcon)
export * from "./twitter";
